import React, { useEffect, useRef } from 'react';

import WindFreeVideo from '../../../../uploads/Photos/Home-Screen/WindFree/Samsung Wind-Free Plus Air Conditioners.mp4'
import WindfreeComfort from '../../../../uploads/Photos/Home-Screen/WindFree/2024-windfree-comfort.mp4'
import WindfreeLowNoise from '../../../../uploads/Photos/Home-Screen/WindFree/windfree-low-noise.mp4'

import WindfreeVoiceControl from '../../../../uploads/Photos/Home-Screen/WindFree/windfree-voice-control.png'
import WindfreeSmartthingsEnergy from '../../../../uploads/Photos/Home-Screen/WindFree/windfree-smartthings-energy.png'

import { Typography } from '@material-tailwind/react';

import './WindFree.css'
import { Helmet } from 'react-helmet';

export default function WindFree() {
    const imageContainerRef = useRef(null);

    useEffect( () =>{
    window.scrollTo({ top: 0 });
    const observer = new IntersectionObserver(
        (entries) => {
          entries.forEach((entry) => {
            if (entry.isIntersecting) {
              entry.target.classList.add('fade-in')
              observer.unobserve(entry.target);
            }
          });
        },
        { threshold: 0.8 }
      );
  
      if (imageContainerRef.current) {
        observer.observe(imageContainerRef.current);
      }
  
      return () => {
        if (imageContainerRef.current) {
          observer.unobserve(imageContainerRef.current);
        }
      };
    }, []);

    return (
        <>
        <Helmet>
            <title>EES | WindFree</title>
            <meta name="title" content="WindFree | Иновативно Ладење Без Промаи" />
            <meta name="description" content="Запознајте се со нашата WindFree технологија која овозможува удобно ладење без премаи." />
            <meta name="keywords" content="WindFree, технологија, ладење, без премаи" />
        </Helmet>
    <div>
        <div className="w-full h-[90.5vh] flex items-center justify-center overflow-hidden">
            <video 
                className="h-full w-full object-cover rounded-lg" 
                loop 
                autoPlay 
                muted 
                playsInline
            >
                <source src={WindFreeVideo} type="video/mp4" />
                Your browser does not support the video tag.
            </video>
        </div>
        <div>
        <div className='flex flex-wrap lg:justify-between xl:justify-between 2xl:justify-between justify-center py-16 px-6 mx-auto sm:max-w-xl md:max-w-full lg:max-w-[95%] xl:max-w-[90%] md:px-24 lg:px-8 rounded-3xl rounded-t-md mt-10'>
            <video 
                className="h-1/2 w-[90%] lg:w-[40%] md:w-[90%] sm:w-[90%] xl:w-[40%] 2xl:w-[40%] object-cover rounded-lg mb-10" 
                autoPlay
                muted
                playsInline
                >
                <source src={WindfreeComfort} type="video/mp4" />
                Your browser does not support the video tag.
            </video>
            <video 
                className="h-1/2 w-[90%] lg:w-[40%] md:w-[90%] sm:w-[90%] xl:w-[40%] 2xl:w-[40%] object-cover rounded-lg" 
                autoPlay
                muted
                playsInline
            >
                <source src={WindfreeLowNoise} type="video/mp4" />
                Your browser does not support the video tag.
            </video>
        </div>
        <div className='flex flex-wrap lg:justify-between xl:justify-between 2xl:justify-between justify-center py-16 px-6 mx-auto sm:max-w-xl md:max-w-full lg:max-w-[95%] xl:max-w-[90%] md:px-24 lg:px-8 rounded-3xl rounded-t-md mt-5'>
            <div className='w-[90%] lg:w-[40%] md:w-[90%] sm:w-[90%] xl:w-[40%] 2xl:w-[40%] text-center'>
                <img
                    src={WindfreeVoiceControl}
                />
                    <Typography className='text-2xl sm:text-xl md:text-3xl lg:text-4xl font-bold text-black w-12/12 drop-shadow-md mt-2 text-center' >
                        Контролирајте го во секое време, каде било
                    </Typography>
                    <Typography className="text-gray-700 text-base mt-5 text-wrap break-words" >
                        Заштитете се од ситни честички. Филтерот PM1.0 заробува ултра ситни честички со помош на електростатички таложник. Светлата во боја го прикажуваат моменталниот квалитет на воздухот и сензорот открива кога воздухот е валкан, така што може автоматски да се чисти⁶. И филтерот што може да се пере е исплатлив за одржување.
                    </Typography>
            </div>
            <div className='w-[90%] lg:w-[40%] md:w-[90%] sm:w-[90%] xl:w-[40%] 2xl:w-[40%] text-center'>
                <img
                    src={WindfreeSmartthingsEnergy}
                />
                <Typography className='text-2xl sm:text-xl md:text-3xl lg:text-4xl font-bold text-black w-12/12 drop-shadow-md mt-2 text-center' >
                    Паметна оптимизација и заштеда на енергија
                </Typography>
                <Typography className="text-gray-700 text-base mt-5 text-wrap break-words" >
                    Контролирајте ја потрошувачката на енергија за да ги намалите вашите сметки. SmartThings Energy ви овозможува лесно да ја проверите потрошувачката на енергија. Ако проценетата количина ја надмине вашата цел, ја прилагодува потрошувачката на енергија на сите паметни апарати. Кога клима уредот е вклучен, ги влече ролетните и ве предупредува ако излезете надвор.
                </Typography>
            </div>
        </div >

        <div style={{ background: '#f7f7f7' }}
        className="py-16 px-6 mx-auto sm:max-w-xl md:max-w-full lg:max-w-[95%] xl:max-w-[90%] md:px-24 lg:px-8 rounded-3xl rounded-t-md mt-5" ref={imageContainerRef} >
            <Typography className='text-2xl sm:text-xl md:text-3xl lg:text-4xl font-bold text-black text-left w-12/12 drop-shadow-md mt-10' >
                Повеќе информации
            </Typography>
            <Typography className="text-gray-700 text-base mt-10 ml-5 w-[80%]" >
                Чувствувајте се удобно без да го нарушите секојдневниот живот. Клима уредите WindFree™ нежно и рамномерно го распрснуваат воздухот низ илјадници микро дупки за воздух што го покриваат целиот преден панел. Добиената многу мала брзина на воздухот генерира помалку воздушно триење и бучава⁵ во споредба со нормалното ладење.
            </Typography>
            <Typography className='text-2xl sm:text-xl md:text-3xl lg:text-4xl font-bold text-black text-left w-12/12 drop-shadow-md mt-10' >
                Се лади 43% побрзо² од агол до агол
            </Typography>
            <Typography className="text-gray-700 text-base mt-10 ml-5 w-[80%]" >
            Изладете ги собите брзо. Двојниот компресор работи стабилно при секоја брзина, бидејќи неговите два цилиндри се ротираат наизменично. Неодимиумските магнети на BLDC моторот се 3 пати посилни од вообичаените, така што генерира моќна и побрза ротација. Така, го лади воздухот 43% побрзо² и го распрснува ладниот воздух подалеку и пошироко³.
            </Typography>
            <Typography className='text-2xl sm:text-xl md:text-3xl lg:text-4xl font-bold text-black text-left w-12/12 drop-shadow-md mt-10' >
                Заштедете енергија, но останете удобни
            </Typography>
            <Typography className="text-gray-700 text-base mt-10 ml-5 w-[80%]" >
                Заштедете енергија и можете да останете удобно кул. Режимот WindFree™ ја намалува непотребната потрошувачка на енергија, бидејќи не мора да продолжи да дува силни експлозии на ладен воздух како нормална операција на ладење. Значи, троши 77% помалку енергија од режимот за брзо ладење⁴.
            </Typography>
            <Typography className='text-2xl sm:text-xl md:text-3xl lg:text-4xl font-bold text-black text-left w-12/12 drop-shadow-md mt-10' >
                Брзо фаќа дури и ултрафина прашина
            </Typography>
            <Typography className="text-gray-700 text-base mt-10 ml-5 w-[80%]" >
            Заштитете се од ситни честички. Филтерот PM1.0 заробува ултра ситни честички со помош на електростатички таложник. Светлата во боја го прикажуваат моменталниот квалитет на воздухот и сензорот открива кога воздухот е валкан, така што може автоматски да се чисти⁶. И филтерот што може да се пере е исплатлив за одржување.
            </Typography>
        </div>
        </div>
    </div>
    </>
    );
}
